import { Checkbox } from "antd";

const Callout: React.FC<any> = ({ setGuidePopover }) => {
  return (
    <div className="callout">
      Add an education to receive 🎉 30 coins
      <div className="dont-show-form">
        <Checkbox onChange={() => console.log(1)}>Don't show again</Checkbox>
      </div>
      <button className="close-btn" onClick={() => setGuidePopover(false)}>
        ×
      </button>
    </div>
  );
};

export default Callout;
